module.exports = __webpack_public_path__ + "static/the-switch-stories-9230c9c323508c7cc738454e01c8b07e.jpg";